// extracted by mini-css-extract-plugin
export default {"container":"AboutMe_container__ptHfM","header":"AboutMe_header__PD3zj","content":"AboutMe_content__7COf2","image":"AboutMe_image__9-22q","text":"AboutMe_text__0VC81"};